<template>
  <div>
    <PricingTable />
    <TheFooter />
  </div>
</template>

<script>
import PricingTable from '../components/pricing';
import TheFooter from '../components/footer.vue'

export default {
  name: 'PricingPage',
  props: [],
  components: {
    PricingTable,
    TheFooter,
  },
  data: function () {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
  mounted() {
  },
}
</script>

<style scoped>
</style>

